export const PaymentTypeEndpoints = {
  LIST: '/api/admin/paymentTypes',
};
